import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseService } from "src/app/base/services/base.service";
import { Observable } from "rxjs";
import { Ordem } from "../models/ordem.model";

@Injectable()
export class OrdemService extends BaseService<Ordem> {

  constructor(public http: HttpClient) {
    super(http);
  }
  public getListCombos(id:number = null): Observable<any> {
    var url = id? '/list/'+id: '/list';
    return this.http.get<any>(this.baseUrl + url , { headers: this.headers });
  }
  public getPathModule(): string {
    return '/reuniao/ordem';
  }
}